import React from 'react'

import { LabelsList } from 'modules/Labels/containers'
import { AdminHeader, Layout } from 'components'
import { LabelsHeader } from '../modules/Labels/components'

const LabelsPage = () => (
  <Layout>
    <AdminHeader>
      <LabelsHeader />
    </AdminHeader>
    <LabelsList />
  </Layout>
)

export default LabelsPage
